import React from "react";
import { useTranslations } from "@danishagro/shared/src/contexts/translations/translations.context";
import { DA_DatePicker } from "@danishagro/shared/src/components/molecules/DatePicker/DatePicker.component";
import { DA_Icon, DA_IconNames } from "@danishagro/shared/src/components/atoms/Icon/Icon.component";
import { DA_Button } from "@danishagro/shared/src/components/atoms/Button/Button.component";
import { format } from "date-fns";
import { useScreen } from "@danishagro/shared/src/contexts/screen.context";
import { useDynamicOverlay } from "@danishagro/shared/src/hooks/dynamicOverlay/useDynamicOverlay.hook";
import S from "./OrderDetailsTimePicker.module.scss";

interface OrderDetailsTimePickerProps {
    fromDate: string;
    toDate: string;
    setFromDate: (date?: string) => void;
    setToDate: (date?: string) => void;
    disabled?: boolean;
}

export const OrderDetailsTimePicker: React.FC<OrderDetailsTimePickerProps> = ({
    fromDate,
    toDate,
    setFromDate,
    setToDate,
    disabled,
}) => {
    const { getDictionaryString } = useTranslations();
    const { isMobileOrTablet } = useScreen();
    const today = format(new Date(), "yyyy-MM-dd");
    const { closeOverlay } = useDynamicOverlay();

    const handleClear = () => {
        setFromDate("");
        setToDate("");
        closeOverlay();
    };

    return (
        <>
            {!isMobileOrTablet && (
                <span className={S.timeTitle}>
                    {getDictionaryString("profile.orderHistory.timePeriod")}
                </span>
            )}
            <div className={S.timePeriodWrapper}>
                <DA_DatePicker
                    disabled={disabled}
                    date={fromDate}
                    minDate=""
                    maxDate={toDate ?? today}
                    datePlaceholder={getDictionaryString("profile.orderHistory.fromDate")}
                    onChange={setFromDate}
                />
                <DA_Icon name={DA_IconNames.ArrowRight} className={S.arrow} />
                <DA_DatePicker
                    disabled={disabled}
                    date={toDate}
                    minDate={fromDate}
                    maxDate={today}
                    datePlaceholder={getDictionaryString("profile.orderHistory.toDate")}
                    onChange={setToDate}
                />
                {(fromDate || toDate) && (
                    <DA_Button
                        small
                        className={S.clearButton}
                        onClick={handleClear}
                        title={getDictionaryString("profile.orderHistory.clear")}
                        icon={DA_IconNames.Close}
                        disabled={disabled}
                    />
                )}
            </div>
        </>
    );
};
